import {Pipe, PipeTransform} from '@angular/core';
import {LanguageHelper} from '../utilities/language-helper';

@Pipe({
    name: 'language',
    standalone: true
})
export class LanguagePipe implements PipeTransform {

  transform(value: string): string {
    const language = LanguageHelper.languageList.find(x => x.code === value.replace('_', '-'));
    return language.name ?? value;
  }
}
